module.exports = __webpack_public_path__ + "img/04-min.c902609f.jpg";